import React from 'react';
import { BaseRoute } from '@core/routing/helper-components/Routes';
import { Subtitles } from '@mui/icons-material';
import { Module } from '@modules/admin/types';
import { OfferConfigProvider } from './contexts/OfferConfigContext';
import OfferList from './pages/OfferList';
import AddEditOffer from './pages/AddEditOffer';
import ViewOffer from './pages/ViewOffer';

// Wrapper component that provides OfferConfigProvider to all offer routes
const OfferRouteWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <OfferConfigProvider>{children}</OfferConfigProvider>
);

// Create wrapped components
const WrappedOfferList = () => (
  <OfferRouteWrapper>
    <OfferList />
  </OfferRouteWrapper>
);

const WrappedAddEditOffer = () => (
  <OfferRouteWrapper>
    <AddEditOffer />
  </OfferRouteWrapper>
);

const WrappedViewOffer = () => (
  <OfferRouteWrapper>
    <ViewOffer />
  </OfferRouteWrapper>
);

export const offerRoutes: BaseRoute[] = [
  {
    path: '/offers',
    component: WrappedOfferList,
    title: 'Offers',
    showInSidebar: true,
    icon: <Subtitles />,
    sidebarText: 'Offers',
    module: Module.OFFER,
    requiresView: true,
  },
  {
    path: '/offers/new',
    component: WrappedAddEditOffer,
    title: 'Create Offer',
    showInSidebar: false,
    module: Module.OFFER,
    requiresAdd: true,
  },
  {
    path: '/offers/:id/edit',
    component: WrappedAddEditOffer,
    title: 'Edit Offer',
    showInSidebar: false,
    module: Module.OFFER,
    requiresUpdate: true,
  },
  {
    path: '/offers/:id',
    component: WrappedViewOffer,
    title: 'View Offer',
    showInSidebar: false,
    module: Module.OFFER,
    requiresView: true,
  },
];
